var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 238308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 40497",
    filter: "url(#filter0_b_6875_9364)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F5A200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6 21.12V32M23.6 21.12C23.6 19.3279 23.6 18.4318 23.9487 17.7473C24.2555 17.1451 24.7452 16.6556 25.3474 16.3488C26.0319 16 26.9276 16 28.7197 16H31.4931C32.0905 16 32.3893 16 32.6174 16.1163C32.8181 16.2185 32.9815 16.3817 33.0838 16.5824C33.2001 16.8106 33.1999 17.1092 33.1999 17.7066V27.0933C33.1999 27.6907 33.2001 27.9894 33.0838 28.2176C32.9815 28.4183 32.8181 28.5814 32.6174 28.6837C32.3893 28.7999 32.0906 28.8 31.4932 28.8H28.4734C27.4716 28.8 26.9708 28.8 26.5161 28.938C26.1136 29.0603 25.7392 29.2607 25.4142 29.5278C25.0471 29.8295 24.7691 30.2463 24.2133 31.0799L23.6 32M23.6 21.12C23.6 19.3279 23.5998 18.4318 23.251 17.7473C22.9442 17.1451 22.4551 16.6556 21.853 16.3488C21.1684 16 20.2723 16 18.4801 16H15.7068C15.1094 16 14.8105 16 14.5823 16.1163C14.3816 16.2185 14.2185 16.3817 14.1163 16.5824C14 16.8106 14 17.1092 14 17.7066V27.0933C14 27.6907 14 27.9894 14.1163 28.2176C14.2185 28.4183 14.3816 28.5814 14.5823 28.6837C14.8105 28.7999 15.1094 28.8 15.7068 28.8H18.7266C19.7284 28.8 20.2293 28.8 20.684 28.938C21.0865 29.0603 21.4609 29.2607 21.7859 29.5278C22.153 29.8295 22.4307 30.2463 22.9864 31.0799L23.6 32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6875_9364",
    x: -30,
    y: -30,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6875_9364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6875_9364",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.ad19aed7601a5801823422eddc47aea4.svg";
export { ForwardRef as ReactComponent };